import type { FC } from 'react';

import type { IVideo } from '@/services/models/Media/Video';

import { Video } from '../../core-ui/Video';
import { MediaPlayer } from '../../core-ui/Video/MediaPlayer';

import { PlaybackButton } from './PlaybackButton';

import S from './styles.module.scss';

interface IPDPVideoProps {
  /** The video to be displayed. */
  video: IVideo;
}

/** A component that renders a video player for the PDP page. */
export const PDPVideo: FC<IPDPVideoProps> = ({ video }) => {
  return (
    <div className={S.container}>
      <MediaPlayer settings={video.settings}>
        <Video video={video} />
        <PlaybackButton />
      </MediaPlayer>
    </div>
  );
};
